<template>
    <v-menu
      :open-on-hover="false"
    >
      <template v-slot:activator="{ on: menu }">
        <v-tooltip v-model="show" bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn :loading="buttonLoad" v-on="{ ...tooltip, ...menu }" :color="iconColor" class="ma-2" text icon >
                <v-icon small>{{icon}}</v-icon>
            </v-btn>               
          </template>
          <span>{{tooltipText}}</span>
        </v-tooltip>
      </template>

      <v-list>
        <v-subheader>
            Rate the stock
            <v-spacer/>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon dense x-small style="color: #e1e4ea; " v-on="on">mdi-alert-circle-outline </v-icon>
                </template>
                <span> Rate this stock to customize your recommendations</span>
            </v-tooltip>    
        </v-subheader>          
        <v-list-item @click="addPreference(1)">
          <v-list-item-icon>
            <v-icon  dark color="primary">{{icon_thumbs_up}}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Like
          </v-list-item-content>                
        </v-list-item>
        <v-list-item @click="addPreference(-1)">
          <v-list-item-icon>
            <v-icon  dark color="#e9507f">{{icon_thumbs_down}}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Dislike
          </v-list-item-content>            
        </v-list-item>
        <v-list-item @click="addPreference(0)">
          <v-list-item-icon>
            <v-icon small dark color="secondary">{{icon_delete}}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Remove
          </v-list-item-content>
        </v-list-item>                          
      </v-list>
    </v-menu>
    <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on }">
 
        </template>                      
        <span>Like/dislike the stock</span>
    </v-tooltip>         -->
</template>

<script>
export default {
  name: "SetPreferences",
  props: {
    stock: String,
    rating: {
      type: Number
      , default: null
    },
    update: {
      type: Boolean,
      default: false
    }    
  },
  data() {
    return {
      message: "",
      ratingValue:0,
      buttonLoad: false,
      errorbar: false,
      icon: "mdi-thumbs-up-down",
      iconColor:"white",
      icon_neutral: "mdi-thumbs-up-down",
      icon_neutral_color:"white",
      icon_thumbs_up: "mdi-thumb-up",
      icon_thumbs_up_color:"primary",      
      icon_thumbs_down: "mdi-thumb-down",
      icon_thumbs_down_color:"#e9507f",      
      icon_delete: "mdi-delete-outline",
      tooltipText: "Your rating on the stock",
      show:false
    };
  },
  mounted() {
    if (this.update & this.rating!= null) {
      this.addPreference(this.rating);
    }
    if (this.rating!= null) {
      this.ratingValue = this.rating;
      this.checkIconValue();
    } 
    //else {
    //  get rating if not provided
    //}
  },
  methods: {
    checkIconValue() {
      if (this.ratingValue==0) {
          this.icon = this.icon_neutral;
          this.iconColor = this.icon_neutral_color;
          this.tooltipText="Rate the stock"
      } else if (this.ratingValue==1) {
          this.icon = this.icon_thumbs_up;
          this.iconColor = this.icon_thumbs_up_color;
          this.tooltipText="You like the stock" 
      } else if (this.ratingValue==-1) {
          this.icon = this.icon_thumbs_down;
          this.iconColor = this.icon_thumbs_down_color;
          this.tooltipText="You do not like the stock"
      }
    },
    async setPreference(action,url) {
      //console.log(url);
      this.$gtag.event('SetPreference', {
        'event_category': 'update',
        'event_label': url,
        'value': action
      })      
      var self = this;
      const currentSession = await this.$Amplify.Auth.currentSession();
      const currentToken = currentSession.getIdToken().getJwtToken();
      this.$http
        .get(process.env.VUE_APP_API_HOST + url + self.stock, {
          headers: {
            Authorization: currentToken,
            "Content-Type": "application/json"
          }
        })
        .then(function(response) {
          self.message = response.data.message;
          self.ratingValue=action;
          self.checkIconValue();
          self.buttonLoad = false;
        })
        .catch(function(error) {
          self.buttonLoad = false;
          //console.log(error.response.data);          
          self.tooltipText = error.response.data.errorMessage;
          self.show=true;
        });
    },
    addPreference(action) {
      this.buttonLoad = true;
      if (action == 1) {
        this.setPreference(action,"/set-preference-like/");
      } else if (action == -1) {
        this.setPreference(action,"/set-preference-dislike/");
      } else if (action == 0) {
        this.setPreference(action,"/set-preference-remove/");
      }
    }
  }
};
</script>